import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCogs,
  faBriefcase,
  faWarehouse,
  faCalculator,
  faWrench,
  faUsers,
  faChartLine,
  faCoins,
  faBook,
  faBuilding,
  faHardHat,
  faHome,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";

const sidebar_options = [
  {
    key: "dashboard",
    label: "dashboard",
    icon: <FontAwesomeIcon icon={faChartLine} />,
    permission_required : false
  },

  /*** INVENTORY */
  {
    key: "inventory",
    label: "inventory",
    icon: <FontAwesomeIcon icon={faWarehouse} />,
    is_root : true,
    permission_required : true,
    children: [
      {
        key: "property-offers",
        label: "property_offers",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "inventory-list",
        label: "inventory_list",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "projects",
        label: "projects",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "selling-price",
        label: "selling_price",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "appraisal-value",
        label: "appraisal_value",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "site-map",
        label: "project_site_map",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "change-item-status",
        label: "change_item_status",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "business-plan",
        label: "business_plan",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module : "inventory",
        permission_required : true,
      },
      {
        key: "inventory-setup",
        label: "setup",
        icon: "",
        module : "inventory",
        permission_required : true,
        children: [
          {
            key: "stages-by-project-classification",
            label: "stages_by_project_classification",
            icon: "",
            module : "inventory",
            permission_required : true,
          },
          {
            key: "market-segment-matrix",
            label: "market_segment_matrix",
            icon: "",
            module : "inventory",
            permission_required : true,
          },
          
          {
            key: "inventory-checklist",
            label: "inventory_checklist",
            icon: "",
            module : "inventory",
            permission_required : true,
          },
          {
            key: "price-factors",
            label: "price_factors",
            icon: "",
            module : "inventory",
            permission_required : true,
          },
          {
            key: "lot-price-parameters",
            label: "lot_price_parameters",
            icon: "",
            module : "inventory",
            permission_required : true,
          }
        ]
      }
    ],
  },

  /*** PURCHASING (HRIS inventory) */
  {
    key: "purchasing",
    label: "purchasing",
    icon: <FontAwesomeIcon icon={faShoppingCart} />,
    is_root: true,
    permission_required: false,
    children: [
      {
        key: "transactions",
        label: "purchasing_transactions",
        module: "purchasing",
        permission_required: false,
        children: [
          { key: "inventory/stock-transfers", label: "stock_transfers", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/transactions/stock-issuance", label: "stock_issuance", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/stockadjustment", label: "stock_adjustment", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/stock-counts", label: "stock_counts", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/record-approval", label: "purchasing_record_approval", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/purchase-orders", label: "purchase_orders", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/stock-receiving", label: "stock_receiving", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/stock-returns", label: "stock_returns", module: "purchasing", navigate_on_click: true, permission_required: false },
        ],
      },
      {
        key: "setup",
        label: "purchasing_setup",
        module: "purchasing",
        permission_required: false,
        children: [
          { key: "inventory/itemmaster", label: "item_master", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/locations", label: "purchasing_locations", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/dropdownrecords", label: "purchasing_dropdown_records", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/approvalmatrix", label: "purchasing_approval_matrix", module: "purchasing", navigate_on_click: true, permission_required: false },
        ],
      },
      {
        key: "reports",
        label: "purchasing_reports",
        module: "purchasing",
        permission_required: false,
        children: [
          { key: "inventory/daily-summary-report", label: "daily_summary_report", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/stocks-inventory-report", label: "stocks_inventory_report", module: "purchasing", navigate_on_click: true, permission_required: false },
          { key: "inventory/transaction-logs", label: "transaction_logs", module: "purchasing", navigate_on_click: true, permission_required: false },
        ],
      },
    ],
  },

  /*** SALES */
  {
    key : "sales",
    label : "sales",
    icon: <FontAwesomeIcon icon={faBriefcase}/>,
    permission_required : true,
    is_root : true,
    children : [
      {
        key: "customer-information",
        label: "customer_information",
        icon: "",
        module : "sales",
        permission_required : true,
      },
      {
        key: "seller-information",
        label: "seller_information",
        icon: "",
        module : "sales",
        permission_required : true,
      },
      {
        key: "sample-computation",
        label: "sample_computation",
        icon: "",
        module : "sales",
        permission_required : true,
      },
      {
        key: "reservation-entry",
        label: "reservation_entry",
        icon: "",
        module : "sales",
        permission_required : true,
      },
      {
        key: "credit-approval",
        label: "credit_approval",
        icon: "",
        module : "sales",
        permission_required : true,
      },
      {
        key: "document-printing",
        label: "document_printing",
        icon: "",
        module : "sales",
        permission_required : true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module : "sales",
        permission_required : true,
      },
      {
        key: "sales-report",
        label: "report",
        icon: "",
        permission_required : true,
        module : "sales",
        children: [
          {
            key: "price-list",
            label: "price_list",
            icon: "",
            module : "sales",
            permission_required : true,
          },
        ]
      },
      {
        key: "sales-setup",
        label: "setup",
        icon: "",
        permission_required : true,
        module : "sales",
        children: [
          {
            key: "reservation-requirements",
            label: "reservation_requirements",
            icon: "",
            module : "sales",
            permission_required : true,
          },
          {
            key: "seller-requirements",
            label: "seller_requirements",
            icon: "",
            module : "sales",
            permission_required : true,
          },
          {
            key: "payment-terms",
            label: "payment_terms",
            icon: "",
            module : "sales",
            permission_required : true,
          },
          {
            key: "promos-and-discounts",
            label: "promos_and_discounts",
            icon: "",
            module : "sales",
            permission_required : true
          },
          {
            key: "disclaimer-statement",
            label: "disclaimer_statement",
            icon: "",
            module : "sales",
            permission_required : false
          },
          {
            key: "mobile-app-announcements",
            label: "mobile_app_announcements",
            icon: "",
            module : "sales",
            permission_required : false
          },
          {
            key: "mobile-app-faq",
            label: "mobile_app_faq",
            icon: "",
            module : "sales",
            permission_required : false
          },
          {
            key: "payment-term-discounts",
            label: "payment_term_discounts",
            icon: "",
            module : "sales",
            permission_required : false
          }
        ]
      }
    ]
  },

  /*** ACCOUNTING */
  {
    key : "accounting",
    label : "accounting",
    icon: <FontAwesomeIcon icon={faCalculator}/>,
    permission_required : true,
    is_root : true,
    children : [
      {
        key: "accounting-module",
        label: "accounting_module",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "employee-information",
        label: "employee_information",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "supplier-information",
        label: "supplier_information",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "item-master",
        label: "item_master",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "item-purchase",
        label: "item_purchase",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "reservation-payment-entry",
        label: "reservation_payment_entry",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "supplier-setup",
        label: "supplier_setup",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
      {
        key: "dropdown-setup",
        label: "dropdown_setup",
        icon: "",
        module : "accounting",
        permission_required : true,
      },
    ]
  },

  /*** COLLECTION */
  {
    key : "collection",
    label : "collection",
    icon: <FontAwesomeIcon icon={faCoins}/>,
    permission_required : true,
    is_root : true,
    children : [
      {
        key: "cash-payments",
        label: "cash_payment",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      {
        key: "check-acceptances",
        label: "check_acceptance",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      {
        key: "check-taggings",
        label: "check_clearing",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      // {
      //   key: "collection-taggings",
      //   label: "collection_tagging",
      //   icon: "",
      //   module : "collection",
      //   permission_required : true,
      // },
      {
        key: "customer-ledger",
        label: "customer_ledger",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      {
        key: "change-payment-details",
        label: "change_payment_details",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      {
        key: "transfer-unit",
        label: "transfer_of_unit",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      {
        key: "transfer-buyer",
        label: "transfer_of_buyer",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module : "collection",
        permission_required : true,
      },
      {
        key: "collection-setup",
        label: "setup",
        icon: "",
        permission_required : true,
        module : "collection",
        children: [
          {
            key: "bank-accounts",
            label: "bank_account",
            icon: "",
            module : "collection",
            permission_required : true,
          },
          {
            key: "check-statuses",
            label: "check_status",
            icon: "",
            module : "collection",
            permission_required : true,
          },
          {
            key: "collection-statuses",
            label: "collection_status",
            icon: "",
            module : "collection",
            permission_required : true,
          },
          {
            key: "mri",
            label: "mri_setup",
            icon: "",
            module : "collection",
            permission_required : true,
          },
        ]
      }
    ]
  },
  
  /*** ACCOUNTS PAYABLE */
  {
    key : "accounts-payable",
    label : "accounts_payable",
    icon: <FontAwesomeIcon icon={faCoins}/>,
    permission_required : true,
    is_root : true,
    children : [
      {
        key: "crf",
        label: "crf",
        icon: "",
        module : "commission",
        permission_required : true,
      }
    ]
  },

  /*** COMMISSION */
  {
    key : "commission",
    label : "commission",
    icon: <FontAwesomeIcon icon={faCoins}/>,
    permission_required : true,
    is_root : true,
    children : [
      {
        key: "commission-ledger",
        label: "commission_ledger",
        icon: "",
        module : "commission",
        permission_required : true,
      },
      {
        key: "commission-processing",
        label: "commission_processing",
        icon: "",
        module : "commission",
        permission_required : true,
      },
      {
        key: "crf",
        label: "crf",
        icon: "",
        module : "commission",
        permission_required : true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module : "commission",
        permission_required : true,
      },
      {
        key: "commission-setup",
        label: "setup",
        icon: "",
        permission_required : true,
        module : "commission",
        children: [
          {
            key: "broker-rate",
            label: "broker_rate",
            icon: "",
            module : "commission",
            permission_required : true,
          },
          {
            key: "commission-matrix",
            label: "commission_matrix",
            icon: "",
            module : "commission",
            permission_required : true,
          },
          {
            key: "vat-misc-fees",
            label: "vat_misc_fees",
            icon: "",
            module : "commission",
            permission_required : true,
          },
        ]
      }
    ]
  },

  
  /*** INCENTIVES */
  {
    key : "incentive",
    label : "incentive",
    icon: <FontAwesomeIcon icon={faCoins}/>,
    permission_required : true,
    is_root : true,
    children : [
      {
        key: "incentive-ledger",
        label: "incentive_ledger",
        icon: "",
        module : "incentive",
        permission_required : true,
      },
      {
        key: "incentive-processing",
        label: "incentive_processing",
        icon: "",
        module : "incentive",
        permission_required : true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module : "incentive",
        permission_required : true,
      },
      {
        key: "incentive-crf",
        label: "crf",
        icon: "",
        module : "incentive",
        permission_required : true,
      },
      {
        key: "incentive-setup",
        label: "setup",
        icon: "",
        permission_required : true,
        module : "incentive",
        children: [
          {
            key: "incentive-matrix",
            label: "incentive_matrix",
            icon: "",
            module : "incentive",
            permission_required : true,
          },
          {
            key: "hierarchy-rate",
            label: "hierarchy_rate",
            icon: "",
            module : "incentive",
            permission_required : true,
          }
        ]
      }
    ]
  },

  /*** DOCUMENTATION */
  {
    key : "documentation",
    label : "documentation",
    icon: <FontAwesomeIcon icon={faBook}/> ,
    permission_required : true,
    is_root : true,
    children: [
      {
        key: "credit-approval-memorandum",
        label: "credit_approval_memorandum",
        icon: "",
        module: "documentation",
        permission_required: true,
        navigate_on_click: true,
      },
      {
        key: "loan-documentation",
        label: "loan_documentation_processing",
        icon: "",
        module: "documentation",
        permission_required: true,
        navigate_on_click: true,
      },
      {
        key: "accreditation-processing",
        label: "accreditation_processing",
        icon: "",
        module: "documentation",
        permission_required: true,
        navigate_on_click: true,
      },
      {
        key: "title-transfer",
        label: "title_transfer_processing",
        icon: "",
        module: "documentation",
        permission_required: true,
        navigate_on_click: true,
      },
      {
        key: "check-request-form",
        label: "check_request_form",
        icon: "",
        module: "documentation",
        permission_required: true,
        navigate_on_click: true,
      },
      {
        key: "record-approvals",
        label: "record_approval",
        icon: "",
        module: "documentation",
        permission_required: true,
        navigate_on_click: true,
      },
      {
        key: "setup",
        label: "setup",
        icon: "",
        module: "documentation",
        permission_required: true,
        children: [
          {
            key: "loan-documentation/setup",
            label: "loan_documentation_setup",
            icon: "",
            module: "documentation",
            permission_key: "loan-documentation/setup",
            permission_required: true,
            navigate_on_click: true,
          },
          {
            key: "accreditation-processing/setup",
            label: "accreditation_processing_setup",
            icon: "",
            module: "documentation",
            permission_key: "accreditation-processing/setup",
            permission_required: true,
            navigate_on_click: true,
          },
          {
            key: "title-transfer/setup",
            label: "title_transfer_setup",
            icon: "",
            module: "documentation",
            permission_key: "title-transfer/setup",
            permission_required: true,
            navigate_on_click: true,
          },
        ],
      },
    ]
  },

  /*** PERMITS */
  {
    key: "permits",
    label: "permits",
    icon: <FontAwesomeIcon icon={faBuilding} />,
    permission_required: true,
    is_root: true,
    children: [
      {
        key: "building-permits",
        label: "building_permits",
        icon: "",
        module: "permits",
        permission_required: true,
      },
      {
        key: "occupancy-permits",
        label: "occupancy_permits",
        icon: "",
        module: "permits",
        permission_required: true,
      },
      {
        key: "permit-crf/list",
        label: "crf",
        icon: "",
        module: "permits",
        permission_required: true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module: "permits",
        permission_required: true,
      },
      {
        key: "permits-setup",
        label: "setup",
        icon: "",
        permission_required: true,
        module: "permits",
        children: [
          {
            key: "building-permit-steps",
            label: "building_permit_steps",
            icon: "",
            module: "permits",
            permission_required: true,
          },
          {
            key: "occupancy-permit-steps",
            label: "occupancy_permit_steps",
            icon: "",
            module: "permits",
            permission_required: true,
          },
          {
            key: "payment-terms",
            label: "payment_terms",
            icon: "",
            module: "permits",
            permission_required: true,
          },
        ],
      },
    ],
  },

  /*** PROJECT MANAGEMENT */
  {
    key: "project-management",
    label: "project_management",
    icon: <FontAwesomeIcon icon={faHardHat} />,
    permission_required: true,
    is_root: true,
    children: [
      {
        key: "construction-units",
        label: "construction_units",
        icon: "",
        module: "project-management",
        permission_required: true,
      },
      {
        key: "record-approvals",
        label: "record_approvals",
        icon: "",
        module: "project-management",
        permission_required: true,
      },
      {
        key: "accounts-payable/crf",
        label: "crf",
        icon: "",
        module: "project-management",
        permission_required: true,
      },
      {
        key: "project-management-setup",
        label: "setup",
        icon: "",
        permission_required: true,
        module: "project-management",
        children: [
          {
            key: "contractors",
            label: "contractors",
            icon: "",
            module: "project-management",
            permission_required: true,
          },
          {
            key: "house-models",
            label: "house_models",
            icon: "",
            module: "project-management",
            permission_required: true,
          },
        ],
      },
    ],
  },

  /*** PROPERTY TURNOVER */
  {
    key: "property-turnover",
    label: "property_turnover",
    icon: <FontAwesomeIcon icon={faHome} />,
    permission_required: true,
    is_root: true,
    children: [
      {
        key: "property-turnover-units",
        label: "property_turnover_units",
        icon: "",
        module: "property-turnover",
        permission_required: true,
      },
      {
        key: "customer-service",
        label: "customer_service",
        icon: "",
        module: "property-turnover",
        permission_required: true,
      },
    ],
  },

  /*** SETUP */
  {
    key: "setup",
    label: "setup",
    icon: <FontAwesomeIcon icon={faWrench} />,
    permission_required : true,
    is_root : true,
    children: [
      {
        key: "dropdown-records",
        label: "dropdown_records",
        icon: "",
        module : "setup",
        permission_required : true,
      },
      {
        key: "vat-misc-fees",
        label: "vat_and_misc_fees",
        icon: "",
        module : "setup",
        permission_required : true,
      },
      {
        key: "record-approval-assignment",
        label: "record_approval_assignment",
        icon: "",
        module : "setup",
        permission_required : true,
      },
    ],
  },

  /*** SETTINGS */
  {
    key: "settings",
    label: "settings",
    icon: <FontAwesomeIcon icon={faCogs} />,
    is_root : true,
    permission_required : true,
    children: [
      // {
      //   key: "users",
      //   label: "users",
      //   icon: "",
      //   url: app_config.userManagementURL,
      // },
      {
        key: "user-accounts",
        label: "user_accounts",
        icon: "",
        module : "settings",
        permission_required : true,
      },
      {
        key: "user-roles",
        label: "user_roles",
        icon: "",
        module : "settings",
        permission_required : true,
      },
      {
        key: "user-role-access",
        label: "user_role_access",
        icon: "",
        module : "settings",
        permission_required : true,
      },
      {
        key: "designations",
        label: "designations",
        icon: "",
        module : "settings",
        permission_required : true,
      },
      {
        key: "departments",
        label: "departments",
        icon: "",
        module : "settings",
        permission_required : true,
      },
    ],
  },

  /*** SUPPORT */
  {
    key : "support",
    label : "support",
    icon : <FontAwesomeIcon icon={faUsers}/>,
    permission_required : false,
    is_root : true,
    children : [
      {
        key: "chat",
        label: "chat",
        icon: "",
        module : "support",
        permission_required : false,
      },
    ]
  }
];

export default sidebar_options;
